import { useState, useEffect } from "react";
import * as XLSX from "xlsx";

export const API          = "https://iy-sp.com/api";
export const ADMIN_SECRET = "admin123";
export const AUTH         = { "Content-Type": "application/json", "Authorization": `Bearer ${ADMIN_SECRET}` };

export const PASS_TYPES = ["pass4", "pass8", "member2x", "memberUnl", "private1", "private3", "private10"];
export const PASS_LABELS = {
  dropin:     "Drop-in",
  pass4:      "4-Class Pass",
  pass8:      "8-Class Pass",
  member2x:   "2x/week Membership",
  memberUnl:  "Unlimited Membership",
  private1:   "Private — 1 Class",
  private3:   "Private — 3 Classes",
  private10:  "Private — 10 Classes",
};

const CLASSES_FALLBACK = [
  { id: "cls_wed", label: "Wed 6pm — Iyengar Yoga" },
  { id: "cls_fri", label: "Fri 10am — Iyengar Yoga" },
  { id: "cls_sat", label: "Sat 8:15am — Iyengar Yoga (Online)" },
  { id: "cls_sun", label: "Sun 10am — Iyengar Yoga (Online)" },
];

export function useClasses() {
  const [classes, setClasses] = useState(CLASSES_FALLBACK);
  useEffect(() => {
    fetch(`${API}/schedule/classes`)
      .then(r => r.json())
      .then(data => {
        const loaded = (data.classes ?? []).map(c => {
          const days  = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
          const day   = days[c.dayOfWeek] ?? "";
          const [h, m] = (c.time ?? "00:00").split(":").map(Number);
          const ampm  = h >= 12 ? "pm" : "am";
          const hour  = h % 12 || 12;
          const time  = `${hour}:${String(m).padStart(2,"0")}${ampm}`;
          const venue = c.venue === "venue_online" ? " (Online)" : "";
          return { id: c.id, label: `${day} ${time}${venue} — ${c.title}`, isPrivate: c.isPrivate };
        });
        if (loaded.length > 0) setClasses(loaded);
      })
      .catch(() => {});
  }, []);
  return classes;
}

export function toLocalDateStr(date) {
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");
}

export function fmtDate(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(typeof dateStr === "string" ? dateStr + (dateStr.length === 10 ? "T12:00:00" : "") : dateStr);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function fmtMoney(n) {
  return "$" + (n ?? 0).toFixed(2);
}

export function currentMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function exportXLSX(sheetName, rows, filename) {
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, filename);
}